import React from 'react';
import { PropTypes } from 'prop-types';
import { Pill, Icon } from './styled';

const LABELS = {
  none: 'None',
  name: 'Name',
  cve: 'CVE',
  external_id: 'External ID'
};

const GroupByPill = ({ ws }) => {
  const value = String(ws?.group_by ?? 'none').toLowerCase();
  const label = LABELS[value] ?? value;

  return (
    <Pill title={ label }>
      <Icon aria-hidden="true" />
      {label}
    </Pill>
  );
};

GroupByPill.propTypes = {
  ws: PropTypes.object.isRequired
};

export default GroupByPill;
